(function () {
  const config = window.theme && window.theme.freeGift;
  if (!config || !config.enabled) return;
  if (!config.giftVariantId || !config.giftProductId) return;

  const triggers = (config.triggers || []).filter(
    (t) => t && typeof t.id === "number",
  );
  if (triggers.length === 0) return;

  function evaluateTriggers(items) {
    const itemProductIds = new Set(items.map((it) => it.product_id));
    const has = (id) => itemProductIds.has(id);

    let result = has(triggers[0].id);
    let pendingOp = triggers[0].nextOp;

    for (let i = 1; i < triggers.length; i++) {
      const present = has(triggers[i].id);
      if (pendingOp === "and") {
        result = result && present;
      } else {
        result = result || present;
      }
      pendingOp = triggers[i].nextOp;
    }
    return result;
  }

  let syncing = false;
  const GIFT_PROPERTY_KEY = "_free_gift";

  async function getCart() {
    const res = await fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: "application/json" },
    });
    return res.json();
  }

  async function addGift() {
    const body = {
      items: [
        {
          id: config.giftVariantId,
          quantity: 1,
          properties: { [GIFT_PROPERTY_KEY]: "true" },
        },
      ],
    };
    await fetch(`${window.routes.cart_add_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    });
  }

  async function removeGiftLine(line) {
    await fetch(`${window.routes.cart_change_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ line, quantity: 0 }),
    });
  }

  async function sync() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await getCart();
      const items = cart.items || [];

      const hasTrigger = evaluateTriggers(items);

      const giftIndex = items.findIndex(
        (it) => it.product_id === config.giftProductId,
      );

      let changed = false;

      if (hasTrigger && giftIndex === -1) {
        await addGift();
        changed = true;
      } else if (!hasTrigger && giftIndex !== -1) {
        await removeGiftLine(giftIndex + 1);
        changed = true;
      } else if (hasTrigger && giftIndex !== -1) {
        const giftItem = items[giftIndex];
        if (giftItem.quantity > 1) {
          await removeGiftLine(giftIndex + 1);
          await addGift();
          changed = true;
        }
      }

      if (changed) {
        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
      }
    } catch (e) {
      console.error("[free-gift] sync failed", e);
    } finally {
      syncing = false;
    }
  }

  function onCartUpdate(event) {
    if (event && event.source === "free-gift") return;
    sync();
  }

  function init() {
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
    sync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
